import { Button } from "antd";
import styled from "styled-components";

export const LogoutContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 400px;
	margin: 0 auto;
	text-align: center;
	margin-top: 150px;
	font-family: Roboto;
`;

export const LogoutTextHeader = styled.div`
	font-weight: bold;
	font-size: 24px;
	line-height: 40px;
	margin-bottom: 20px;
`;

export const LogoutText = styled.div`
	font-size: 24px;
	line-height: 40px;
	margin-bottom: 20px;
`;

export const LoginButton = styled(Button)`
	background-color: #0b74ec !important;
	color: #fff;
	width: 160px;
	height: 50px;
	justify-content: center;
	margin: 0 auto;
	font-family: "Roboto" !important;
	box-shadow: none;
	&:hover {
		color: #fff !important;
		opacity: 0.8;
		transition: opacity 0.4s ease;
	}
`;

export const MainHeaderContainer = styled.header`
  color: #fff;
  padding: 15px 40px;
  height: 80px;
  background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 4;
`;


export const Logo = styled.img`
  width: 200px;
  height: 30px;
  position: relative;
  z-index: 4;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  font-family: "Roboto";
  position: relative;
  z-index: 3;
  height: 100%; 
`;